// extracted by mini-css-extract-plugin
export default {"wrapper":"THi_RJ","pinIcon":"aFc57W","pinned":"tA5Oe8","category":"Dm36Lj","title":"xBf3Gh","confirmMessage":"XlpABs","date":"RjaBcm","save":"mdHfob"};